export default "__VITE_ASSET__Giyv7XJo__"